import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Spinner, Card } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../utils/httpProvider';
import { QUYETDINHCAPVIEN_API, BaseGatewayImage } from '../../../../utils/apiUrl';
import { trangThaiGuiKetQuaValue } from '../../../../utils/define';
import DocumentInput from '../../../../components/document-input/DocumentInput';
import { ConfirmModal } from '../../../../modules/modal/ConfirmModal';
import moment from 'moment';

const FieldDisplayFile = ({ label, value }) => {
    const getSafeUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
        const safePath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${safePath}`;
    };

    let files = [];
    if (value) {
        try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) {
                files = parsed;
            } else {
                files = [{ filePath: value, name: value.split('/').pop() }];
            }
        } catch (e) {
            files = [{ filePath: value, name: value.split('/').pop() }];
        }
    }

    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold">{label}</Form.Label>}
            <div className="d-flex flex-wrap">
                {files.length > 0 ? (
                    files.map((file, idx) => {
                        const path = file.filePath || file;
                        let name = file.name || (typeof path === 'string' ? path.split('/').pop() : 'File');
                        name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                        return (
                            <a key={idx} href={getSafeUrl(path)} target="_blank" rel="noreferrer" className={`btn btn-outline-primary text-left ${label ? '' : 'btn-sm'} mb-1 mr-1`} style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                <i className="fas fa-paperclip mr-1"></i> {name}
                            </a>
                        );
                    })
                ) : (
                    <span className="text-muted small">Không có file</span>
                )}
            </div>
        </Form.Group>
    );
};

const FieldDisplay = ({ label, value }) => {
    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold">{label}</Form.Label>}
            <div>
                <span className="text-dark" style={{ fontSize: '15px', fontWeight: 600, whiteSpace: 'pre-wrap' }}>
                    {value !== null && value !== undefined && value !== '' ? value : <span className="text-muted font-italic" style={{ fontWeight: 'normal' }}>Chưa cập nhật</span>}
                </span>
            </div>
        </Form.Group>
    );
};

const QuyetDinhCapVienForm = ({ baoVeCapVienId, readOnly = false, isUserView = false, onDataLoaded, onSaveSuccess }) => {
    const [saving, setSaving] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    
    const [quyetDinhCapVienId, setQuyetDinhCapVienId] = useState(null);
    const [soQuyetDinh, setSoQuyetDinh] = useState('');
    const [ngayBanHanh, setNgayBanHanh] = useState('');
    const [fileQuyetDinh, setFileQuyetDinh] = useState('');
    
    const [soThanhVien, setSoThanhVien] = useState('');
    const [soNguoiKhoaHoc, setSoNguoiKhoaHoc] = useState('');
    const [soNguoiTienSi, setSoNguoiTienSi] = useState('');
    
    const [isDuDieuKien, setIsDuDieuKien] = useState(true);
    const [isDungChuyenNganh, setIsDungChuyenNganh] = useState(true);
    const [isCapDuoiTrucTiep, setIsCapDuoiTrucTiep] = useState(true);
    
    const [trangThaiGuiKetQua, setTrangThaiGuiKetQua] = useState(trangThaiGuiKetQuaValue.chuaGui);

    const { data: queryRes, refetch, isLoading } = useQuery(
        ['quyetDinhCapVienData', baoVeCapVienId], 
        () => Get(`${QUYETDINHCAPVIEN_API.GET_BY_BAOVE_ID}/${baoVeCapVienId}`),
        { 
            enabled: !!baoVeCapVienId,
            refetchOnWindowFocus: false 
        }
    );

    const parseTrangThaiGuiKetQua = (val) => {
        if (typeof val === 'number') return val;
        if (val === 'DaGui') return trangThaiGuiKetQuaValue.daGui;
        return trangThaiGuiKetQuaValue.chuaGui;
    };

    useEffect(() => {
        if (queryRes) {
            let item = null;
            if (Array.isArray(queryRes)) {
                item = queryRes[0];
            } else if (queryRes.data && Array.isArray(queryRes.data)) {
                item = queryRes.data[0];
            } else if (queryRes.data?.$values) {
                item = queryRes.data.$values[0];
            } else if (queryRes.data) {
                item = queryRes.data;
            } else {
                item = queryRes;
            }

            if (item && item.id) {
                setQuyetDinhCapVienId(item.id);
                setSoQuyetDinh(item.soQuyetDinh || '');
                setNgayBanHanh(item.ngayBanHanh ? moment(item.ngayBanHanh).format('YYYY-MM-DD') : '');
                setFileQuyetDinh(item.fileQuyetDinh || '');
                setSoThanhVien(item.soThanhVien != null ? item.soThanhVien : '');
                setSoNguoiKhoaHoc(item.soNguoiKhoaHoc != null ? item.soNguoiKhoaHoc : '');
                setSoNguoiTienSi(item.soNguoiTienSi != null ? item.soNguoiTienSi : '');
                setIsDuDieuKien(item.isDuDieuKien || false);
                setIsDungChuyenNganh(item.isDungChuyenNganh || false);
                setIsCapDuoiTrucTiep(item.isCapDuoiTrucTiep || false);
                setTrangThaiGuiKetQua(parseTrangThaiGuiKetQua(item.trangThaiGuiKetQua));
                if (onDataLoaded) onDataLoaded(true);
            } else {
                if (onDataLoaded) onDataLoaded(false);
            }
        } else if (queryRes === null) {
            if (onDataLoaded) onDataLoaded(false);
        }
    }, [queryRes]);

    const handleSave = async (isSend = false) => {
        setSaving(true);
        try {
            const payload = {
                BaoVeCapVienId: baoVeCapVienId,
                SoQuyetDinh: soQuyetDinh || '',
                NgayBanHanh: ngayBanHanh || null,
                FileQuyetDinh: fileQuyetDinh || '',
                SoThanhVien: soThanhVien !== '' ? Number(soThanhVien) : null,
                SoNguoiKhoaHoc: soNguoiKhoaHoc !== '' ? Number(soNguoiKhoaHoc) : null,
                SoNguoiTienSi: soNguoiTienSi !== '' ? Number(soNguoiTienSi) : null,
                IsDuDieuKien: isDuDieuKien,
                IsDungChuyenNganh: isDungChuyenNganh,
                IsCapDuoiTrucTiep: isCapDuoiTrucTiep,
                TrangThaiGuiKetQua: isSend ? trangThaiGuiKetQuaValue.daGui : trangThaiGuiKetQua
            };

            if (quyetDinhCapVienId) {
                await Put(QUYETDINHCAPVIEN_API.UPDATE_ITEM, quyetDinhCapVienId, { ...payload, Id: quyetDinhCapVienId });
            } else {
                await Post(QUYETDINHCAPVIEN_API.CREATE, null, payload);
            }

            toast.success(isSend ? 'Gửi kết quả thành công!' : 'Lưu thông tin thành công!');
            await refetch();
            if (onSaveSuccess) onSaveSuccess();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu kết quả.');
        } finally {
            setSaving(false);
            setShowConfirm(false);
        }
    };

    const handleOpenConfirm = () => {
        setShowConfirm(true);
    };

    if (isLoading) return <div className="text-center p-3"><Spinner animation="border" variant="primary" /></div>;

    const isDaGui = trangThaiGuiKetQua === trangThaiGuiKetQuaValue.daGui;

    if (isUserView && !isDaGui) {
        return (
            <div className="text-center p-5 text-muted">
                <i className="fas fa-file-alt fa-3x mb-3 text-secondary"></i>
                <h5>Chưa có kết quả quyết định cấp viện</h5>
                <p>Kết quả quyết định cấp viện sẽ hiển thị ở đây khi được Phòng HLĐT cập nhật và gửi tới bạn.</p>
            </div>
        );
    }

    return (
        <div className="bg-white p-3 rounded">
            <Card className="mb-3 border-info shadow-sm">
                <Card.Header className="bg-info text-white font-weight-bold">Thành lập hội đồng đánh giá luận án tiến sĩ cấp viện</Card.Header>
                <Card.Body>
                    <Row>
                        {((!readOnly && !isUserView) || (soQuyetDinh && soQuyetDinh !== '')) && (
                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label="Số quyết định" value={soQuyetDinh} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold">Số quyết định</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={soQuyetDinh}
                                        onChange={(e) => setSoQuyetDinh(e.target.value)}
                                        placeholder="Nhập số quyết định..."
                                        disabled={readOnly || isUserView}
                                        className={readOnly || isUserView ? "bg-white" : ""}
                                    />
                                </Form.Group>
                            )}
                        </Col>
                        )}
                        {((!readOnly && !isUserView) || (ngayBanHanh && ngayBanHanh !== '')) && (
                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label="Ngày ban hành" value={ngayBanHanh ? moment(ngayBanHanh).format('DD/MM/YYYY') : ''} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold">Ngày ban hành</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={ngayBanHanh}
                                        onChange={(e) => setNgayBanHanh(e.target.value)}
                                        disabled={readOnly || isUserView}
                                        className={readOnly || isUserView ? "bg-white" : ""}
                                    />
                                </Form.Group>
                            )}
                        </Col>
                        )}

                        {((!readOnly && !isUserView) || soThanhVien !== '') && (
                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label="Số thành viên thuộc cơ sở đào tạo" value={soThanhVien} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold">Số thành viên thuộc cơ sở đào tạo</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={soThanhVien}
                                        onChange={(e) => setSoThanhVien(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Nhập số thành viên..."
                                        disabled={readOnly || isUserView}
                                        className={readOnly || isUserView ? "bg-white" : ""}
                                    />
                                </Form.Group>
                            )}
                        </Col>
                        )}
                        {((!readOnly && !isUserView) || soNguoiKhoaHoc !== '') && (
                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label="Số người có chức danh khoa học" value={soNguoiKhoaHoc} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold">Số người có chức danh khoa học</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={soNguoiKhoaHoc}
                                        onChange={(e) => setSoNguoiKhoaHoc(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Nhập số người..."
                                        disabled={readOnly || isUserView}
                                        className={readOnly || isUserView ? "bg-white" : ""}
                                    />
                                </Form.Group>
                            )}
                        </Col>
                        )}
                        {((!readOnly && !isUserView) || soNguoiTienSi !== '') && (
                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label="Số người chỉ có học vị tiến sĩ" value={soNguoiTienSi} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold">Số người chỉ có học vị tiến sĩ</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={soNguoiTienSi}
                                        onChange={(e) => setSoNguoiTienSi(e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                        placeholder="Nhập số người..."
                                        disabled={readOnly || isUserView}
                                        className={readOnly || isUserView ? "bg-white" : ""}
                                    />
                                </Form.Group>
                            )}
                        </Col>
                        )}
                        
                        <Col md={6} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label="Đủ điều kiện là thành viên hội đồng" value={isDuDieuKien ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold">Đủ điều kiện là thành viên hội đồng</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isDuDieuKien"
                                            checked={isDuDieuKien === true}
                                            onChange={() => setIsDuDieuKien(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isDuDieuKien"
                                            checked={isDuDieuKien === false}
                                            onChange={() => setIsDuDieuKien(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>
                        
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label="Người phản biện trong Hội đồng có đúng chuyên ngành" value={isDungChuyenNganh ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold">Người phản biện trong Hội đồng có đúng chuyên ngành</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isDungChuyenNganh"
                                            checked={isDungChuyenNganh === true}
                                            onChange={() => setIsDungChuyenNganh(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isDungChuyenNganh"
                                            checked={isDungChuyenNganh === false}
                                            onChange={() => setIsDungChuyenNganh(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>
                        
                        <Col md={12} className="mb-3">
                            {readOnly || isUserView ? (
                                <FieldDisplay label="Người phản biện có phải là cấp dưới trực tiếp của NCS" value={isCapDuoiTrucTiep ? 'Có' : 'Không'} />
                            ) : (
                                <Form.Group>
                                    <Form.Label className="font-weight-bold">Người phản biện có phải là cấp dưới trực tiếp của NCS</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Có"
                                            name="isCapDuoiTrucTiep"
                                            checked={isCapDuoiTrucTiep === true}
                                            onChange={() => setIsCapDuoiTrucTiep(true)}
                                        />
                                        <Form.Check 
                                            inline
                                            type="radio"
                                            label="Không"
                                            name="isCapDuoiTrucTiep"
                                            checked={isCapDuoiTrucTiep === false}
                                            onChange={() => setIsCapDuoiTrucTiep(false)}
                                        />
                                    </div>
                                </Form.Group>
                            )}
                        </Col>
                        
                        {((!readOnly && !isUserView) || (fileQuyetDinh && fileQuyetDinh !== '[]' && fileQuyetDinh !== 'null')) && (
                        <Col md={12}>
                            {readOnly || isUserView ? (
                                <FieldDisplayFile label="File quyết định" value={fileQuyetDinh} />
                            ) : (
                                <Form.Group>
                                    <DocumentInput
                                        labelTitle="File quyết định"
                                        value={fileQuyetDinh}
                                        onChangeProp={(url) => setFileQuyetDinh(url)}
                                        readOnly={readOnly || isUserView}
                                    />
                                </Form.Group>
                            )}
                        </Col>
                        )}
                    </Row>
                </Card.Body>
            </Card>

            {!readOnly && !isUserView && (
                <div className="text-right mt-4">
                    <Button variant="success" onClick={() => handleSave(false)} disabled={saving}>
                        {saving ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-save mr-1"></i>}
                        Lưu thông tin
                    </Button>
                    <Button variant="primary" className="ml-2" onClick={handleOpenConfirm} disabled={saving}>
                        {saving ? <><Spinner size="sm" animation="border" className="mr-2" /> Đang gửi...</> : <><i className="fas fa-paper-plane mr-2"></i> {isDaGui ? 'Gửi lại kết quả' : 'Gửi kết quả'}</>}
                    </Button>
                </div>
            )}

            <ConfirmModal
                isOpen={showConfirm}
                title="Xác nhận gửi kết quả"
                content={
                    <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                        Lưu ý: Khi gửi thông tin này, quyết định sẽ được gửi tới nghiên cứu sinh. Bạn có chắc chắn muốn gửi không?
                    </div>
                }
                labelAccept="Đồng ý gửi"
                handleAccept={() => handleSave(true)}
                handleCancel={() => setShowConfirm(false)}
            />
        </div>
    );
};

export default QuyetDinhCapVienForm;
